import Box from 'components/shared/Box'
import Text from 'components/shared/Text'
import Input from 'components/shared/Input'
import { useIntl } from 'react-intl'
import { useErrorMessages } from 'utils/hooks/useErrorMessages'
import { useAppDispatch } from 'store/hooks'
import { setShippingInfo, ShippingField } from 'store/order-slice'
import { useEffect } from 'react'

const DeliveryByEmailForm = () => {
    const { formatMessage } = useIntl()
    const { getError, handleRemoveError } = useErrorMessages()
    const dispatch = useAppDispatch()

    const handleInputChange = (field: ShippingField, value: string) => {
        dispatch(setShippingInfo({ field, value }))
    }

    useEffect(() => {
        dispatch(setShippingInfo({ field: 'email', value: '' }))
    }, [])

    return (
        <Box>
            <Text variant="heading4" mb={[16, 24]}>
                {formatMessage({
                    id: 'selfcare.payment.voucher_email_address',
                    defaultMessage:
                        'Adres e-mail, na który zostaną wysłane Vouchery',
                })}
            </Text>

            <Input
                id="shippingData.email"
                type="email"
                placeholder={formatMessage({
                    id: 'global.input.email_placeholder',
                    defaultMessage: 'Adres e-mail',
                })}
                label={formatMessage({
                    id: 'global.input.email_label',
                    defaultMessage: 'Adres e-mail',
                })}
                isRequired
                onValueChange={(value) => {
                    handleRemoveError('shippingData.email')
                    handleInputChange('email', value)
                }}
                isError={!!getError('shippingData.email')}
                errorMessage={getError('shippingData.email')}
                onBlurChange={(value) => handleInputChange('email', value)}
                autofill="email"
                testId="payment-field-delivery-email"
            />
        </Box>
    )
}

export default DeliveryByEmailForm
